import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_metronic/partials'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import AccountWrapper from "../pages/accounts/AccountWrapper";
import GrantAccessWrapper from "../pages/accounts/GrantAccessWrapper";
import { usePermissionChecker } from '../../app/hooks/PermissionChecker'
import { LIST_PERMISSIONS } from '../../app/constants/common'
import ImportRequestWrapper from '../pages/warehouse/import-request/ImportRequestWrapper'
import ViewImportRequestWrapper from '../pages/warehouse/import-request/detail/ViewImportRequestWrapper'
import WareHouseReportWrapper from '../pages/warehouse-report/WareHouseReportWrapper';
import ImportRequestHistWrapper from '../pages/warehouse/import-request-histories/ImportRequestHistWrapper';
import PaymentRequestWrapper from '../pages/payment-request/PaymentRequestWrapper';
import AccountInfoWrapper from '../pages/personnel-info/AccountInfoWrapper';


export function PrivateRoutes() {
  const { hasPermission } = usePermissionChecker();
  const ProductsWrapper = lazy(() => import('../pages/products/ProductsWrapper'))

  const renderRoute = (path: string, component: any, requiredPermission?: string) => {
    if (requiredPermission && !hasPermission(requiredPermission)) {
      return <Redirect to="/error/404" />;
    }
    return <Route exact path={path} component={component} />;
  };

  const protectedRoutes = [
    { path: '/accounts/list', component: AccountWrapper, permission: LIST_PERMISSIONS.ACCOUNTS },
    { path: '/account/add', component: AccountWrapper, permission: LIST_PERMISSIONS.ACCOUNTS },
    { path: '/account/edit/:id', component: AccountWrapper, permission: LIST_PERMISSIONS.ACCOUNTS },
    { path: '/accounts/roles', component: GrantAccessWrapper, permission: LIST_PERMISSIONS.ACCOUNTS },
    { path: '/products', component: ProductsWrapper, permission: LIST_PERMISSIONS.PRODUCTS },
    { path: '/products/detail', component: ProductsWrapper, permission: LIST_PERMISSIONS.PRODUCTS },
    { path: '/products/detail/:id?', component: ProductsWrapper, permission: LIST_PERMISSIONS.PRODUCTS },
    { path: '/warehouse/receipt/import-requests', component: ImportRequestWrapper, permission: LIST_PERMISSIONS.IMPORT_REQUEST },
    { path: '/warehouse/receipt/import-requests/:id', component: ViewImportRequestWrapper, permission: LIST_PERMISSIONS.IMPORT_REQUEST },
    { path: '/warehouse-report', component: WareHouseReportWrapper, permission: LIST_PERMISSIONS.WAREHOUSE_REPORT },
    { path: '/warehouse/import-histories', component: ImportRequestHistWrapper, permission: LIST_PERMISSIONS.WAREHOUSE_LOGS },
    { path: '/payment-request', component: PaymentRequestWrapper, permission: LIST_PERMISSIONS.PAYMENT_REQUEST },
  ];

  const normalRoutes = [
    { path: '/', component: DashboardWrapper },
    { path: '/dashboard', component: DashboardWrapper },
    { path: '/my-account', component: AccountInfoWrapper },
  ];
  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {protectedRoutes.map((route) => (
          <Route exact key={route.path} path={route.path}>
            {renderRoute(route.path, route.component, route.permission)}
          </Route>
        ))}
        {normalRoutes.map((route) => (
          <Route exact key={route.path} path={route.path} component={route.component} />
        ))}
        {/*<Redirect from='/' to='/dashboard' />*/}
      </Switch>
    </Suspense>
  );
}
